/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Speechmatics_Target_Language_LithuanianInputs */

const en_speechmatics_target_language_lithuanian = /** @type {(inputs: Speechmatics_Target_Language_LithuanianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lithuanian`)
};

const fr_speechmatics_target_language_lithuanian = /** @type {(inputs: Speechmatics_Target_Language_LithuanianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lituanien`)
};

const de_speechmatics_target_language_lithuanian = /** @type {(inputs: Speechmatics_Target_Language_LithuanianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`litauisch`)
};

const it_speechmatics_target_language_lithuanian = /** @type {(inputs: Speechmatics_Target_Language_LithuanianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`lituano`)
};

const ru_speechmatics_target_language_lithuanian = /** @type {(inputs: Speechmatics_Target_Language_LithuanianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`литовский`)
};

const es_speechmatics_target_language_lithuanian = /** @type {(inputs: Speechmatics_Target_Language_LithuanianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`lituano`)
};

const zh_cn2_speechmatics_target_language_lithuanian = /** @type {(inputs: Speechmatics_Target_Language_LithuanianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`立陶宛语`)
};

const ja_speechmatics_target_language_lithuanian = /** @type {(inputs: Speechmatics_Target_Language_LithuanianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`リトアニア語`)
};

const hi_speechmatics_target_language_lithuanian = /** @type {(inputs: Speechmatics_Target_Language_LithuanianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`लिथुआनियाई`)
};

const pt_pt2_speechmatics_target_language_lithuanian = /** @type {(inputs: Speechmatics_Target_Language_LithuanianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`lituano`)
};

/**
* | output |
* | --- |
* | "Lithuanian" |
*
* @param {Speechmatics_Target_Language_LithuanianInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const speechmatics_target_language_lithuanian = /** @type {((inputs?: Speechmatics_Target_Language_LithuanianInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Speechmatics_Target_Language_LithuanianInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_speechmatics_target_language_lithuanian(inputs)
	if (locale === "de") return de_speechmatics_target_language_lithuanian(inputs)
	if (locale === "it") return it_speechmatics_target_language_lithuanian(inputs)
	if (locale === "ru") return ru_speechmatics_target_language_lithuanian(inputs)
	if (locale === "es") return es_speechmatics_target_language_lithuanian(inputs)
	if (locale === "zh-CN") return zh_cn2_speechmatics_target_language_lithuanian(inputs)
	if (locale === "ja") return ja_speechmatics_target_language_lithuanian(inputs)
	if (locale === "hi") return hi_speechmatics_target_language_lithuanian(inputs)
	if (locale === "pt-PT") return pt_pt2_speechmatics_target_language_lithuanian(inputs)
	return en_speechmatics_target_language_lithuanian(inputs)
});